// extracted by mini-css-extract-plugin
export default {"borderBg":"styles_borderBg__hTiiJ","borderStroke":"styles_borderStroke__YCw40","borderFill":"styles_borderFill__xRxpl"};